/**
 * Pusher Configuration
 * 
 * This file handles Pusher configuration using environment variables.
 * Make sure to set REACT_APP_PUSHER_KEY and REACT_APP_PUSHER_CLUSTER in your environment files.
 */

const getPusherConfig = () => {
  const pusherKey = process.env.REACT_APP_PUSHER_KEY;
  const pusherCluster = process.env.REACT_APP_PUSHER_CLUSTER || 'ap1';

  if (!pusherKey) {
    console.error('Pusher key is not configured. Please set REACT_APP_PUSHER_KEY in your environment variables.');
    return null;
  }

  return {
    key: pusherKey,
    cluster: pusherCluster,
    encrypted: true,
  };
};

export default getPusherConfig;

